(function ($) {
    $(".thumbnail-img").on("click", function () {
        if ($(this).css('opacity') == "1") {
            $("#videoPresentation")[0].src += "&autoplay=1";
            $(this).animate({
                opacity: 0,
            }, 600, function () {
            });
            setTimeout(
                function () {
                }, 600);
            $(this).addClass("d-none");

        } else {

        }
    });

    $(".modal-trig a").attr("data-bs-toggle", "modal");
    $(".modal-trig a").attr("data-bs-target", "#newsletterModal");


    $(".hblog-button img").mouseenter(function () {
        $(this).attr("src", document.URL + "/wp-content/themes/vestiges-child/assets/play_video_button_hovered.svg");
    });
    $(".hblog-button img").mouseleave(function () {
        $(this).attr("src", document.URL + "/wp-content/themes/vestiges-child/assets/play_video_button.svg");
    });

    $(".copy-link").on("click", function () {
        var idLink = $(this).attr('id');
        var hashtag = '';

        if (parent.location.hash !== '') {
            parent.location.hash = '';
        } else {
            hashtag = '#';
        }
        var linkToCopy = window.location.href + hashtag + idLink;

        console.log(linkToCopy);

        var tempTextarea = $('<textarea>');
        $('body').append(tempTextarea);
        tempTextarea.val(linkToCopy).select();
        document.execCommand('copy');
        tempTextarea.remove();
        $('<div>', {
            id: 'tooltipLink',
            class: 'copy-link-tooltip',
            html: 'Link copied'
        }).appendTo($(this)).animate({
            opacity: 1,
        }, 100).animate({
            opacity: 0,
        }, 1000);
        setTimeout(function() {
            $('#tooltipLink').remove();
        }, 1100);


    });
})(jQuery);